import { PlacesPage } from "../places/PlacesPage";

export function WecommendationsPage() {
  return <PlacesPage mode="wecommendations" />;
}

